import { BaseInput, BaseInputProps } from "../primitive/BaseInput";

export interface TextAreaInputProps extends Omit<BaseInputProps, "type"> {
    value: string;
    onValueChange: (newValue: string) => void;
    rows: number;
}

export const TextAreaInput = (props: TextAreaInputProps) => {
    return (
        <BaseInput
            type="textarea"
            {...props}
            onValueChange={val => props.onValueChange(String(val))}
        />
    )
}